import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { components } from "@entities/journal";
import {
  $journalApi,
  journalQueryOptions,
} from "@entities/journal/fetch/fetch-client.ts";
import { updateSectionTwoRecordSigned } from "../api/update-section-two-record-signed.ts";
import { mapSectionTwoRequest } from "./map-section-two-request";

interface IUseUpdateSectionTwoRecord {
  sectionTwoId: string;
  sectionTwoListId: string;
  versionId: string;
  itemNoVersionId: string;
}

type Response = components["schemas"]["SectionTwoItemVersionUpdateResponse"];

interface IRequest {
  mainJournalId: string;
  section2Id: string;
  section2ListId: string;
  specialJournalName: string;
  specialJournalDate: string;
  journalKeepersList?: Array<any>;
  dateHandover?: string | null;
  signer: string;
  file?:
    | { file?: File | null | undefined; id?: string | null | undefined }
    | null
    | undefined;
  actionDetails: string;
}

export function useUpdateSectionTwoRecordSigned({
  sectionTwoId,
  sectionTwoListId,
  versionId,
  itemNoVersionId,
}: IUseUpdateSectionTwoRecord) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IRequest) => {
      return updateSectionTwoRecordSigned({
        sectionTwoListId,
        versionId,
        updateSectionTwoRequest: mapSectionTwoRequest({
          mainJournalId: data.mainJournalId,
          section2Id: data.section2Id,
          section2ListId: data.section2ListId,
          specialJournalName: data.specialJournalName,
          specialJournalDate: data.specialJournalDate,
          journalKeepersList: data.journalKeepersList,
          dateHandover: data.dateHandover,
          signer: data.signer,
        }),
        actionDetails: data.actionDetails,
        file: data.file,
      });
    },
    onSuccess: async (data: Response) => {
      queryClient.invalidateQueries({
        queryKey: $journalApi.queryOptions(
          "get",
          "/api/v1/journals/section-two/{sectionTwoId}",
          { params: { path: { sectionTwoId } } },
        ).queryKey,
      });

      queryClient.setQueryData(
        journalQueryOptions(
          "get",
          "/api/v1/journals/section-two/items/{itemNoVersionId}",
          { params: { path: { itemNoVersionId } } },
        ).queryKey,
        data,
      );
    },
  });
}
